export class Level2WidgetDetailParam {
    CustomerId:string;
    FacilityId: string;
    PageNumber : number;
    PageSize : number;
    WidgetType : string;
    WaveNumber:string;
    StoreNumber:string;
    StoreDesc:string;
    PickupTime:string;
}


// WEBPACK FOOTER //
// ./src/app/models/Level2WidgetDetailParam.ts